{
	"watchList": {
		"ticker": "Ticker",
		"company": "Company",
		"price": "Price",
		"watchListChangeColumnDollar": "Change $",
		"watchListChangeColumnPercent": "Change %",
		"actionsColumn": "Actions",
		"empty": "You haven't added anything to your watchlist",
		"actions": {
			"getFail": "Failed to get watchlist",
			"deleteSuccess": "{{symbol}} removed from watchlist",
			"deleteFail": "Failed to remove {{symbol}} from watchlist",
			"addSuccess": "{{symbol}} added to watchlist",
			"addFail": "Failed to add {{symbol}} to watchlist",
			"delete": "Delete"
		},
		"addStocks": "Add stocks"
	}
}
